import type { CustomComponent } from '../../config/types.js'

export type CustomUpload = CustomComponent
